import React from "react";
import { Divider } from "@material-ui/core";

export const FormDivider = () => <Divider style={{ marginBottom: "20px" }} />;
